module.exports = __webpack_public_path__ + "img/packed_with_love.90af2ba.svg";